import { useState, useEffect } from "react";
import sanityClient from "../sanityClient";
import { postQuery } from "../queries/postQuery";
import { StandardLayout } from "../layouts/StandardLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PortableTextComponent from "../components/PortableText/PortableText";
import TagList from "../components/TagList/TagList";
import { formatDate } from "../util/formatDate";
import { PostLayout } from "../layouts/PostLayout";

export default function SinglePost() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [postData, setPostData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { slug } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const handleBackClick = () => {
        navigate(-1);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        if (!slug) return;

        setIsLoading(true);
        sanityClient
            .fetch(postQuery, { slug })
            .then((data) => {
                if (data) {
                    setPostData(data);
                } else {
                    setError("Post not found.");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setError("Failed to fetch post.");
                setIsLoading(false);
            });
    }, [slug]);

    if (isLoading) {
        return <StandardLayout title="Loading..." content="Loading..." />;
    }

    if (error) {
        return <StandardLayout title="Error" content={error} />;
    }

    if (!postData) {
        return <StandardLayout title="Not Found" content="This post could not be found." />;
    }

    const content = (
        <>
            <h2 style={{ color: "var(--postDate)", fontSize: "1.2em" }}>
                {formatDate(postData.date)}
            </h2>
            <TagList tags={postData.tags} />
            <hr style={{ border: "1px dashed var(--text)" }} />
            <PortableTextComponent content={postData.body} />
        </>
    );

    return (
        <PostLayout
            title={postData.title}
            content={content}
            handleBackClick={handleBackClick}
            scrollToTop={scrollToTop}
        />
    );
}
